import { createReducer } from "utils/context";
import { AUTH_ACTIONS } from "./actions";

export const initialState = {
  // global identifier for auth
  isLoggedIn: false,

  // userData
  userData: null,
};

export const authReducer = createReducer({
  // --- login state management
  [AUTH_ACTIONS.login.loading]: (state) => ({
    ...state,
    loginLoading: true,
    loginError: null,
  }),

  [AUTH_ACTIONS.login.success]: (state, { payload }) => ({
    ...state,
    isLoggedIn: true,
    userData: payload,
    loginLoading: false,
    loginError: null,
  }),

  [AUTH_ACTIONS.login.failure]: (state, { payload }) => ({
    ...state,
    loginLoading: false,
    loginError: payload,
  }),

  // --- update user data
  [AUTH_ACTIONS.logout]: (state) => ({
    ...state,
    isLoggedIn: false,
    userData: null,
  }),

  // --- update user data
  [AUTH_ACTIONS.updateUserData]: (state, { payload }) => ({
    ...state,
    userData: { ...state?.userData, ...payload },
  }),
});
